const Background = () => import('views/bg/Background')
const MyWallet = () => import('views/bg/my/MyWallet')
const MyHistory = () => import('views/bg/my/MyHistory')
const MyFav = () => import('views/bg/my/MyFav')
const MyRcmd = () => import('views/bg/my/MyRcmd')

export default {
  path: '/bg/my',
  redirect: '/bg',
  name: 'My',
  title: '我的数据',
  icon: 'el-icon-s-data',
  component: Background,
  meta: { needAuth: true, roles: ['tnb_user'] },
  children: [
    {
      path: '/bg/my/album',
      name: 'MyFav',
      title: '收藏夹',
      icon: 'el-icon-s-data',
      component: MyFav,
      meta: { needAuth: true, roles: ['tnb_user'] }
    },
    {
      path: '/bg/my/history',
      name: 'MyHistory',
      title: '历史记录',
      icon: 'el-icon-s-data',
      component: MyHistory,
      meta: { needAuth: true, roles: ['tnb_user'] }
    },
    {
      path: '/bg/my/rcmd',
      name: 'Rcmd',
      title: '我的推荐',
      icon: 'el-icon-s-data',
      component: MyRcmd,
      meta: { needAuth: true, roles: ['tnb_user'] }
    },
    {
      path: '/bg/my/wallet',
      name: 'MyWallet',
      title: '我的钱包',
      icon: 'el-icon-s-data',
      component: MyWallet,
      meta: { needAuth: true, roles: ['tnb_user'] }
    }
  ]
}
